var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NCODE_CLASS6_NUM_DOTS } from "../../../common/constants/NcodeConstants";
import { codePos, _debugNcode_w, _glyphDistancePx_canvas } from "./codePositionDefinition";
function drawNcodeSingleLine_DOT(context, code_txt, ncodeMargin, y, width, dpi, fullOfGlyphs = true) {
    const { ctx, x: baseX, y: baseY } = context;
    const multiple = (dpi / 600);
    const glyphStringSkipLeft = Math.round(ncodeMargin.left * NCODE_CLASS6_NUM_DOTS);
    const glyphDistancePx_canvas = _glyphDistancePx_canvas * multiple;
    const dpiCodePos = {
        "u": { code: codePos["u"].code, dx: codePos["u"].dx * multiple, dy: codePos["u"].dy * multiple },
        "d": { code: codePos["d"].code, dx: codePos["d"].dx * multiple, dy: codePos["d"].dy * multiple },
        "l": { code: codePos["l"].code, dx: codePos["l"].dx * multiple, dy: codePos["l"].dy * multiple },
        "r": { code: codePos["r"].code, dx: codePos["r"].dx * multiple, dy: codePos["r"].dy * multiple },
        "n": { code: codePos["n"].code, dx: codePos["n"].dx * multiple, dy: codePos["n"].dy * multiple },
    };
    // const radius = 1 * multiple;
    const sizeBox = 2 * multiple;
    return new Promise(resolve => {
        /** for debugging */
        if (!fullOfGlyphs)
            width = _debugNcode_w;
        ctx.fillStyle = "rgba(0,0,0,255)";
        ctx.lineWidth = 0;
        ctx.imageSmoothingEnabled = false;
        // ctx.imageSmoothingEnabled = true;
        // ctx.imageSmoothingQuality = "high";
        let charIndex = glyphStringSkipLeft;
        for (let x = 0; x < width; x += glyphDistancePx_canvas) {
            if (charIndex >= 0) {
                const glyph = code_txt[charIndex];
                const pos = dpiCodePos[glyph];
                let dx = 0, dy = 0;
                if (pos) {
                    dx = pos.dx;
                    dy = pos.dy;
                }
                ctx.beginPath();
                ctx.rect(baseX + x + dx, baseY + y + dy, sizeBox, sizeBox);
                // ctx.arc(baseX + x + dx, baseY + y + dy, radius, 0, Math.PI * 2);
                ctx.fill();
            }
            charIndex++;
        }
        resolve();
    });
}
function drawNcodeSingleLine(context, code_txt, ncodeMargin, y, width, codeDensity, dpi, fullOfGlyphs = true) {
    // if (codeDensity > 2) {
    //   return drawNcodeSingleLine_BOLD(context, code_txt, ncodeMargin, y, fullOfGlyphs);
    // }
    // else {
    //   return drawNcodeSingleLine_NORMAL(context, code_txt, ncodeMargin, y, fullOfGlyphs);
    // }
    return drawNcodeSingleLine_DOT(context, code_txt, ncodeMargin, y, width, dpi, fullOfGlyphs);
}
export default function drawNcodeOnCanvas(context, surfaceDesc, dpi, ncodeMargin, debugMode) {
    return __awaiter(this, void 0, void 0, function* () {
        // kitty
        const DEBUG_MODE = debugMode;
        const { glyphData } = surfaceDesc;
        const { width, height } = context;
        const glyphDistancePx_canvas = Math.round(dpi * 8 / 600);
        const glyphStringSkipTop = Math.round(ncodeMargin.top * NCODE_CLASS6_NUM_DOTS);
        const codeDrawingPromises = new Array(0);
        const result = {
            success: false,
            dpi,
            pixelsPerDot: glyphDistancePx_canvas,
            dotsPerCell: NCODE_CLASS6_NUM_DOTS,
            rect: {
                unit: "nu",
                x: 0, y: 0, width: 0, height: 0,
            }
        };
        if (glyphData.length < 1) {
            console.log("ERROR: no ncode data given");
            return result;
        }
        const ctx = context.ctx;
        ctx.save();
        ctx.fillStyle = "rgba(0,0,0,255)";
        const glyphStrings = glyphData.split("\r\n");
        if (glyphStrings.length < 7) {
            return result;
        }
        //  const glyph_y = codePaperInfo.Ymin * dotsInACell;
        let glyph_y = glyphStringSkipTop;
        try {
            let y = 0;
            // for (y = 0; y < debugNcode_h; y += glyphDistancePx_canvas) {
            //   if (glyph_y >= 0) {
            //     const codeTxtSingleLine = glyphStrings[glyph_y];
            //     const pr = drawNcodeSingleLine(context, codeTxtSingleLine, ncodeMargin, y, width, 1, dpi, true);
            //     codeDrawingPromises.push(pr);
            //   }
            //   glyph_y++;
            // }
            for (; y < height; y += glyphDistancePx_canvas) {
                // console.log(`${height / glyphDistancePx_canvas} => ${glyph_y} / ${glyphStrings.length}`);
                if (glyph_y >= 0) {
                    const codeTxtSingleLine = glyphStrings[glyph_y];
                    const pr = drawNcodeSingleLine(context, codeTxtSingleLine, ncodeMargin, y, width, 1, dpi, !(DEBUG_MODE > 1));
                    codeDrawingPromises.push(pr);
                }
                glyph_y++;
            }
            ctx.restore();
        }
        catch (e) {
            ctx.restore();
            console.error(e);
            return result;
        }
        yield Promise.all(codeDrawingPromises);
        const successResult = Object.assign(Object.assign({}, result), { success: true, rect: {
                unit: "nu",
                x: ncodeMargin.left,
                y: ncodeMargin.top,
                width: Math.ceil(width / (NCODE_CLASS6_NUM_DOTS * glyphDistancePx_canvas)),
                height: Math.ceil(height / (NCODE_CLASS6_NUM_DOTS * glyphDistancePx_canvas)),
            } });
        return successResult;
    });
}
//# sourceMappingURL=drawNcodeOnCanvas.js.map